import UserGuide from '@/assets/user-guide.pdf'

export function Help() {
  return (
    <>
      <embed src={UserGuide} width="700px" height="800px"></embed>
    </>
  )
}
